import * as actionTypes from "../constants/actionTypes";

// reducer initial state
export const initialState = {
  byIds: {},
  allIds: [],
  loaded: false,
  fetching: false,
  error: undefined
};

function setModelExport(state, modelExport) {
  const byIds = { ...state.byIds, [modelExport.id]: modelExport };
  const allIds = Object.keys(byIds);

  return {
    ...state,
    byIds,
    allIds
  };
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_MODEL_EXPORT:
      return setModelExport(state, action.payload.modelExport);
    case actionTypes.CLEAR_MODEL_EXPORT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/modelExports.js